import { Injectable, Inject } from '@angular/core';
import * as _ from 'lodash';
import moment from 'moment';
import { Subject, of } from 'rxjs';

@Injectable()
export class CacheService {

    memoryCache = {};
    timeCache = 60;

    className = 'CacheService';

    constructor() { }

    canUseCache(key, params?) {

        const name = this.formatName(key, params);
        // console.log("Cache Key: ", key)
        // console.log("Cache Params: ", params)

        if (!_.get(this.memoryCache, name)) {
            _.set(this.memoryCache, name, { "data": null, "lastReqDate": null });
        }
        let oldDate = _.get(this.memoryCache, `${name}.lastReqDate`);
        let canUse = false;
        if (moment().diff(oldDate, 'minutes') <= this.timeCache) {
            canUse = true;
        }
        // console.log("Memory Cache: " , this.memoryCache)
        // console.log("Can use Cache: ", canUse)
        // console.log("-----------------------------------------------------")
        return canUse;
    }

    getCacheData(key, params?) {

        const name = this.formatName(key, params);

        return _.get(this.memoryCache, `${name}.data`) ? of(_.get(this.memoryCache, `${name}.data`)) : _.get(this.memoryCache, `${name}.observer`);
    }

    getCacheSearchs(key, params?) {
        const name = this.formatName(key, params);

        let cacheParam = _.find(this.memoryCache, this.memoryCache[name])

        return cacheParam;
    }

    updateCacheData(data, key, params?) {

        const name = this.formatName(key, params);
        _.set(this.memoryCache, `${name}.data`, data);
        if(!_.get(this.memoryCache, `${name}._subject`)){
            let _subject = new Subject<any>();
            _.set(this.memoryCache, `${name}._subject`, _subject);
        }
        _.get(<any>this.memoryCache, `${name}._subject`).next(data); //Obtiene un error al obtener la memory cache del siguiente valor
    }

    updateCacheReq(key, params?) {

        const name = this.formatName(key, params);

        let _subject = new Subject<any>();
        let observer = _subject.asObservable();
        _.set(this.memoryCache, name, { observer, _subject, lastReqDate: moment() });
    }

    deleteCache(key) {

        const keys = _.filter(_.keysIn(this.memoryCache), (prop) => { return prop.indexOf(key) !== -1 });

        // console.log("Keys" , keys);
        if (keys && keys.length > 0) {
            _.forEach(keys, (name: any) => {
                delete this.memoryCache[name];
            })
        }
    }

    formatName(key, params) {
        let name = `${key}`;

        if (params) {
            name = `${key}_` + _.join(params, '_');
        }

        return name;
    }

    checkExistsfiltersCache(key) {
        const name = this.formatName(key, null);
        let exists = false;

        if(_.get(this.memoryCache, name)) {
            exists = true;
        }
        return exists;
    }

    deleteAllCache() {

        const keys = _.filter(_.keysIn(this.memoryCache));
        // console.log("Keys: ", keys);
        if (keys && keys.length > 0) {
            _.forEach(keys, (name: any) => {
                delete this.memoryCache[name];
            })
        }
    }
}